import { render, staticRenderFns } from "./wallConnection.vue?vue&type=template&id=37e55968&scoped=true&"
import script from "./wallConnection.vue?vue&type=script&lang=js&"
export * from "./wallConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e55968",
  null
  
)

export default component.exports